import { SuggestionOptions } from '@tiptap/suggestion';

import { Suggestion } from 'src/components/tiptap/custom-extensions/SlashMenuRenderer';

export const getSlashMenuSuggestionItems: SuggestionOptions['items'] = ({
  query,
}: {
  query: string;
}) => {
  const actions: Suggestion[] = [
    {
      icon: 'H2',
      title: 'Heading 2',
      command: ({ editor, range }) => {
        editor
          .chain()
          .focus()
          .deleteRange(range)
          .setNode('heading', { level: 2 })
          .run();
      },
    },
    {
      icon: 'H3',
      title: 'Heading 3',
      command: ({ editor, range }) => {
        editor
          .chain()
          .focus()
          .deleteRange(range)
          .setNode('heading', { level: 3 })
          .run();
      },
    },
    {
      title: 'Text',
      icon: 'Text',
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode('paragraph').run();
      },
    },
    {
      title: 'Bullet list',
      icon: 'UnorderedList',
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleBulletList().run();
      },
    },
    {
      icon: 'NumberedList',
      title: 'Numbered list',
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleOrderedList().run();
      },
    },
  ];

  return actions.filter((item) =>
    item.title.toLowerCase().includes(query.toLowerCase()),
  );
};
